/*
 * testimonialsAction.js
 * trt_cms2
 *
 * Created by Hisyam on 09/03/2020, 3:29 PM.
 * Copyright (c) 2020 Terato Tech. All rights reserved.
 */

import {
  ADD_CAREER_FULFILLED,
  ADD_TESTIMONIAL,
  ADD_TESTIMONIAL_FULFILLED,
  DELETE_CAREER,
  DELETE_CAREER_FULFILLED, DELETE_TESTIMONIAL, DELETE_TESTIMONIAL_FULFILLED,
  FETCH_TESTIMONIAL,
  FETCH_TESTIMONIAL_FULFILLED,
  FETCH_TESTIMONIALS,
  FETCH_TESTIMONIALS_FULFILLED,
  RESET_REDIRECT_CAREER, RESET_REDIRECT_TESTIMONIAL,
  UPDATE_CAREER,
  UPDATE_CAREER_FULFILLED,
  UPDATE_TESTIMONIAL,
  UPDATE_TESTIMONIAL_FULFILLED
} from "../types";
import {ofType} from "redux-observable";
import {catchError, debounceTime, map, mapTo, switchMap, withLatestFrom} from "rxjs/operators";
import {ajax} from "rxjs/ajax";
import {CAREERS_API, TESTIMONIALS_API} from "../../config/api";
import {apiHeader, encodeQueryData} from "../../config/helper";
import {of} from "rxjs";
import {returnErrors} from "../messages/messagesAction";

export const fetchTestimonials = (limit, offset, params={}) => ({type: FETCH_TESTIMONIALS, payload: {limit: limit, offset: offset, ...params}});
const fetchTestimonialsFulfilled = (payload) => ({type: FETCH_TESTIMONIALS_FULFILLED, payload: payload});
export const fetchTestimonialsEpic = (action$, state$) => action$.pipe(
  ofType(FETCH_TESTIMONIALS),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(([action, state]) => ajax.getJSON(TESTIMONIALS_API + `?${encodeQueryData(action.payload)}`, apiHeader(state)).pipe(
    map(response => fetchTestimonialsFulfilled(response)),
    catchError(({response, status}) => of(returnErrors(response, status)))
  ))
);

export const fetchTestimonial = (id) => ({type: FETCH_TESTIMONIAL, payload: id});
const fetchTestimonialFulfilled = payload => ({type: FETCH_TESTIMONIAL_FULFILLED, payload: payload});
export const fetchTestimonialEpic = (action$, state$) => action$.pipe(
  ofType(FETCH_TESTIMONIAL),
  withLatestFrom(state$),
  switchMap(([action, state]) => ajax.getJSON(TESTIMONIALS_API + `${action.payload}/`, apiHeader(state)).pipe(
    map((response) => fetchTestimonialFulfilled(response)),
    catchError(({response, status}) => of(returnErrors(response, status)))
  )),
);

export const addTestimonial = (testimonial) => ({type: ADD_TESTIMONIAL, payload: testimonial});
const addTestimonialFulfilled = (payload) => ({type: ADD_TESTIMONIAL_FULFILLED, payload: payload});
export const addTestimonialEpic = (action$, state$) => action$.pipe(
  ofType(ADD_TESTIMONIAL),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(([action, state]) => ajax.post(TESTIMONIALS_API, action.payload, apiHeader(state))
    .pipe(
      map(({response}) => addTestimonialFulfilled(response)),
      catchError(({response, status}) => of(returnErrors(response, status)))
    )
  )
);

export const updateTestimonial = (id, testimonial) => ({type: UPDATE_TESTIMONIAL, payload: testimonial, id: id});
const updateTestimonialFulfilled = (payload) => ({type: UPDATE_TESTIMONIAL_FULFILLED, payload: payload});
export const updateTestimonialEpic = (action$, state$) => action$.pipe(
  ofType(UPDATE_TESTIMONIAL),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(([action, state]) => ajax.put(TESTIMONIALS_API + `${action.id}/`, action.payload, apiHeader(state))
    .pipe(
      map(({response}) => updateTestimonialFulfilled(response)),
      catchError(({response, status}) => of(returnErrors(response, status)))
    )
  )
);

export const deleteTestimonial = id => ({type: DELETE_TESTIMONIAL, id: id});
const deleteTestimonialFulfilled = (id) => ({type: DELETE_TESTIMONIAL_FULFILLED, payload: id});
export const deleteTestimonialEpic = (action$, state$) => action$.pipe(
  ofType(DELETE_TESTIMONIAL),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(
    ([action, state]) => ajax.delete(TESTIMONIALS_API + `${action.id}/`, apiHeader(state))
      .pipe(
        map(() => deleteTestimonialFulfilled(action.id)),
        catchError(({response, status}) => of(returnErrors(response, status)))
      )
  )
);

export const resetRedirectTestimonialEpic = action$ => action$.pipe(
  ofType(ADD_TESTIMONIAL_FULFILLED, UPDATE_TESTIMONIAL_FULFILLED, DELETE_TESTIMONIAL_FULFILLED),
  mapTo({type: RESET_REDIRECT_TESTIMONIAL})
);

export const testimonialsEpic = [
  fetchTestimonialsEpic,
  fetchTestimonialEpic,
  addTestimonialEpic,
  updateTestimonialEpic,
  deleteTestimonialEpic,
  resetRedirectTestimonialEpic,
];